// client/src/pages/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div style={{ textAlign: 'center', padding: '3rem', fontFamily: 'Arial' }}>
      <h1>404 – Page Not Found</h1>
      <p>Oops! The page you're looking for doesn’t exist.</p>
      <Link to="/" style={{ marginTop: '1rem', display: 'inline-block', color: '#27ae60', textDecoration: 'underline' }}>
        ← Back to LuckyLogic.ai Home
      </Link>
    </div>
  );
};

export default NotFound;
